import React from "react";
import colors from "../../../styles/colors";
import styled from "styled-components";
import BarGraph from "../../feature/BarGraph";
import CountUp from "react-countup";
import {
  IoPersonSharp,
  IoCarSportSharp,
  IoHammerSharp,
  IoFitnessSharp,
} from "react-icons/io5";

const TopWrap = styled.div`
  width: 100%;
  display: flex;
  padding: 24px 30px 30px 30px;
`;
const TopMenu = styled.div`
  width: 25%;
  height: 114px;
  color: ${colors.darkerGray};
  padding: 10px;
  background: ${(props) =>
    props.state ? `${colors.activeBlue}` : `${colors.whiteColor}`};
  ${(props) =>
    props.borderRight &&
    `border-right: 1px solid ${colors.emptyBackgroundColor};`}
`;
const MenuInfoBox = styled.div`
  padding-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;
`;
const MenuInfo = styled.div`
  display: inline-block;
  margin-bottom: 17px;
`;
const MenuIcon = styled.div`
  font-size: 24px;
  margin-bottom: 5px;
  height: 24px;
  color: ${colors.darkestGray};
`;
const MenuText = styled.span`
  font-size: 18px;
  color: ${(props) => (props.color ? props.color : `${colors.darkestGray}`)};
  ${(props) => props.state && `color: ${colors.whiteColor};`}
`;
const MenuNumber = styled.span`
  font-size: 44px;
  color: ${(props) => (props.color ? props.color : `${colors.darkestBlack}`)};
  ${(props) => props.state && `color: ${colors.whiteColor};`}
`;

function ContentTop({
  menuNumber,
  title1,
  title2,
  title3,
  title4,
  iconVisible = false,
  barGraphVisible1 = false,
  barGraphVisible2 = false,
  barGraphVisible3 = false,
  barGraphVisible4 = false,
  barGraphColor1,
  barGraphColor2,
  barGraphColor3,
  barGraphColor4,
  menuNumberColor1,
  menuNumberColor2,
  menuNumberColor3,
  menuNumberColor4,
  current = {
    total: false,
    auction: false,
    fail: false,
    done: false,
  },
  totalClick,
  auctionClick,
  failClick,
  doneClick,
  postCountData,
  salesCountData = {
    allSalesPostCount: 0,
    cancelCount: 0,
    completeCount: 0,
    observationCount: 0,
    registerCount: 0,
    tradingCount: 0,
  },
  userCountData = {
    allUserCount: 0,
  },
}) {
  const { total, auction, fail, done } = current;
  const {
    allSalesPostCount,
    cancelCount,
    completeCount,
    observationCount,
    registerCount,
    tradingCount,
  } = salesCountData;

  const UserChart = (userCountData.allUserCount / 1000) * 100;
  const AuctionChart = (allSalesPostCount / 1000) * 100;
  const DealChart = (tradingCount / 100) * 100;
  const DoneChart = (completeCount / 1000) * 100;
  return (
    <TopWrap>
      <TopMenu borderRight onClick={totalClick} state={total}>
        <MenuInfoBox>
          <MenuInfo>
            <MenuIcon>{iconVisible && <IoPersonSharp />}</MenuIcon>
            <MenuText color={menuNumberColor1} state={total}>
              {title1}
            </MenuText>
          </MenuInfo>
          <MenuNumber color={menuNumberColor1} state={total}>
            <CountUp end={userCountData.allUserCount} />
          </MenuNumber>
        </MenuInfoBox>
        {barGraphVisible1 && (
          <BarGraph percent={UserChart} color={barGraphColor1} />
        )}
      </TopMenu>
      <TopMenu borderRight onClick={auctionClick} state={auction}>
        <MenuInfoBox>
          <MenuInfo>
            <MenuIcon>{iconVisible && <IoHammerSharp />}</MenuIcon>
            <MenuText state={auction}>{title2}</MenuText>
          </MenuInfo>
          <MenuNumber color={menuNumberColor2} state={auction}>
            <CountUp end={allSalesPostCount} />
          </MenuNumber>
        </MenuInfoBox>
        {barGraphVisible2 && (
          <BarGraph percent={AuctionChart} color={barGraphColor2} />
        )}
      </TopMenu>
      <TopMenu borderRight onClick={failClick} state={fail}>
        <MenuInfoBox>
          <MenuInfo>
            <MenuIcon>{iconVisible && <IoFitnessSharp />}</MenuIcon>
            <MenuText state={fail}>{title3}</MenuText>
          </MenuInfo>
          <MenuNumber color={menuNumberColor3} state={fail}>
            <CountUp end={tradingCount} />
          </MenuNumber>
        </MenuInfoBox>
        {barGraphVisible3 && (
          <BarGraph percent={DealChart} color={barGraphColor3} />
        )}
      </TopMenu>
      <TopMenu onClick={doneClick} state={done}>
        <MenuInfoBox>
          <MenuInfo>
            <MenuIcon>{iconVisible && <IoCarSportSharp />}</MenuIcon>
            <MenuText color={menuNumberColor4} state={done}>
              {title4}
            </MenuText>
          </MenuInfo>
          <MenuNumber color={menuNumberColor4} state={done}>
            <CountUp end={completeCount} />
          </MenuNumber>
        </MenuInfoBox>
        {barGraphVisible4 && (
          <BarGraph percent={DoneChart} color={barGraphColor4} />
        )}
      </TopMenu>
    </TopWrap>
  );
}

export default ContentTop;
